module.exports = __webpack_public_path__ + "img/1.98bed539.webp";